import { render, staticRenderFns } from "./RespostaPesquisa.vue?vue&type=template&id=2cbd5206&"
import script from "./RespostaPesquisa.vue?vue&type=script&lang=js&"
export * from "./RespostaPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports